// extracted by mini-css-extract-plugin
export default {"mainDiv":"TVCardImage_mainDiv__vNcOT","short":"TVCardImage_short__wITBN","shortCard":"TVCardImage_shortCard__nJgw9"};